module.exports = __webpack_public_path__ + "img/moneyTrial.5d70967e.png";